export default "__VITE_ASSET__Pots2ch7__"